module.exports = __webpack_public_path__ + "img/planta_03.6ceb1385.png";